import { IExpertSystemOrderSummary } from '@nkr/models/index';

export interface IExpertSystemOrderSummaryWithComments extends IExpertSystemOrderSummary {
    newComments: string,
    isChanged: boolean
}